import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Check } from "@mui/icons-material";
import { useSettingContext } from "context/SettingContext";
import { getUserWhatsUpsRights, updateLocationWithWhatsUpNumber, useSelectUser } from "features/Setting/Waba_Rights/apis/wabaRightApi";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { findSpecificPage, findSpecificSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border: 1px solid #fff;
  max-height: 75vh;
  overflow: auto;
  position: relative;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

const StyledTable = styled(Table)(({}) => ({
  "& thead": {
    backgroundColor: "#444444",
    position: "sticky",
    top: 0,
    zIndex: 1,
    "& th": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      padding: "10px",
      borderBottom: "1px solid #fff",
    },
  },
  "& tbody": {
    "& td": {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      borderBottom: "1px solid #fff",
      padding: "10px 5px",
      border: "1px solid #fff",
    },
  },
  "& th": {
    // backgroundColor: "#444444",
    height: "50px",
    // position: "sticky",
    // top: 0,
    // zIndex: 1,
  },
}));

const StyledTableHeaderCell = styled(({ width, ...rest }) => <TableCell {...rest} />)`
  width: ${(props) => props.width || "25%"};
  padding: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: ${(props) => props.color || "#444444"};
  color: white;
  text-align: center !important;
  position: sticky;
  top: 0;
  z-index: 10;
  border: none !important;
`;

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid #fff;
  & td {
    padding: 5px;
  }
`;

const StyledTableBodyCell = styled(({ width, ...rest }) => <TableCell {...rest} />)`
  width: ${(props) => props.width || "25%"};
  padding: 10px;
  text-align: center;
`;

const CustomUncheckedIcon = styled("span")`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  border: 2px solid white;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomCheckedIcon = styled("span")`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  background-color: #50c878;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  & svg {
    width: 20px;
    height: 20px;
  }
`;

const WabaRights = () => {
  const { setWaba, setSaveRightModalOpen, saveRightModalOpen, setVibrateButton, selectRoleBtnName, setSelectRoleBtnName, setSelectRoleOptions, selectRoleOptions, setEnableSaveLimitsBtn } =
    useSettingContext();
  const { data } = useSelectUser();
  const permissions = usePermissions();
  const users = data?.data?.User;
  // console.log("users--->>>",users);
  const hasWabaEditAccess = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permissions), "Waba Rights"), "edit");

  const [wabaTableData, setWabaTableData] = useState([
    { srNo: 1, wabaName: "BBM - 98206 11622", access: false },
    { srNo: 2, wabaName: "BBS - 95121 09700", access: false },
    { srNo: 3, wabaName: "HQ - 95530 90000", access: false },
    { srNo: 4, wabaName: "GCC - 95184 90000", access: false },
  ]);
  const [backendWhatsAppData, setBackendWhatsAppData] = useState([]);

  const compareChanges = () => {
    const currentSelected = wabaTableData.filter((item) => item.access).map((item) => item.wabaName);

    const sortedCurrent = [...currentSelected].sort();
    const sortedBackend = [...backendWhatsAppData].sort();

    const noChange = sortedCurrent.length === sortedBackend.length && sortedCurrent.every((val, i) => val === sortedBackend[i]);

    return !noChange;
  };

  const handleCheckboxChange = (index) => {
    const updatedData = [...wabaTableData];
    updatedData[index].access = !updatedData[index].access;
    setWabaTableData(updatedData);
    setEnableSaveLimitsBtn(compareChanges());
  };

  const formatBackendData = (data) => {
    return data.map((item) => {
      const key = Object.keys(item)[0]; // e.g., "BBM"
      const value = item[key]; // e.g., "9820611622"

      // Format the number: insert space after 5 digits
      const formattedNumber = value.replace(/^(\d{5})(\d{5})$/, "$1 $2");

      return `${key} - ${formattedNumber}`; // e.g., "BBM - 98206 11622"
    });
  };

  const saveChanges = async () => {
    const selectedUser = selectRoleOptions.find((data) => data.roleName === selectRoleBtnName);
    if (!selectedUser?.userId) return;

    const selectedWaba = wabaTableData.filter((item) => item.access);

    // Extract only the location keys (e.g., "BBM" from "BBM - 98206 11622")
    const selectedLocations = selectedWaba.map((item) => item.wabaName.split(" - ")[0]);

    const payload = {
      userId: selectedUser.userId,
      locations: selectedLocations,
    };

    try {
      await updateLocationWithWhatsUpNumber(payload);
      // Update backend data & UI
      const formattedBackend = selectedWaba.map((item) => item.wabaName);
      setBackendWhatsAppData(formattedBackend);
      setEnableSaveLimitsBtn(false);
      setSaveRightModalOpen(false);
    } catch (err) {
      console.error("Failed to save WhatsApp rights:", err);
    }
  };

  const btnInfo = [
    {
      btnName: "No",
      bgColor: "#E77B7B",
      click: () => {
        setSaveRightModalOpen(false);
      },
    },
    {
      btnName: "Yes",
      bgColor: "#50c878",
      click: () => {
        saveChanges();
      },
    },
  ];

  useEffect(() => {
    setWaba(true);
    setSelectRoleBtnName("Select User");
    if (Array.isArray(users)) {
      const options = users.map((data, index) => ({
        roleName: data?.username,
        userId: data?._id,
      }));
      setSelectRoleOptions(options);
      setWabaTableData(wabaTableData.map((item) => ({ ...item, access: false })));
    }
    return () => {
      setWaba(false);
      setSelectRoleOptions([]);
      setSelectRoleBtnName("");
      setEnableSaveLimitsBtn(false);
      setVibrateButton(false);
      setWabaTableData([]);
    };
  }, [users]);

  useEffect(() => {
    const fetchWhatsAppRightsofUser = async () => {
      const selectedUser = selectRoleOptions.find((data) => data.roleName === selectRoleBtnName);

      if (!selectedUser?.userId) return;

      const whatsAppdata = await getUserWhatsUpsRights(selectedUser?.userId);

      if (whatsAppdata?.whatsUpData) {
        const formattedBackend = formatBackendData(whatsAppdata.whatsUpData);
        setBackendWhatsAppData(formattedBackend);

        const updatedwabaTableData = wabaTableData.map((item) => ({
          ...item,
          access: formattedBackend.includes(item.wabaName),
        }));

        setWabaTableData(updatedwabaTableData);
      }
    };

    fetchWhatsAppRightsofUser();
  }, [selectRoleBtnName]);

  return (
    <>
      <div style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px", backgroundColor: "#000", padding: "10px" }}>
        <StyledTableContainer>
          <StyledTable>
            <TableHead>
              <TableRow>
                <StyledTableHeaderCell width="20%">Sr no.</StyledTableHeaderCell>
                <StyledTableHeaderCell width="40%">Waba</StyledTableHeaderCell>
                <StyledTableHeaderCell width="40%">Access</StyledTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {wabaTableData.map((elm, i) => (
                <StyledTableRow key={i}>
                  <StyledTableBodyCell width="20%">{elm.srNo}.</StyledTableBodyCell>
                  <StyledTableBodyCell width="40%">{elm.wabaName}</StyledTableBodyCell>
                  <StyledTableBodyCell width="40%">
                    <Checkbox
                      disableRipple
                      checked={elm.access}
                      onChange={
                        selectRoleBtnName === "Select User"
                          ? () => setVibrateButton(true)
                          : hasWabaEditAccess // Add this condition
                            ? () => handleCheckboxChange(i)
                            : () => setVibrateButton(true) // Or some other feedback for no access
                      }
                      icon={<CustomUncheckedIcon />}
                      checkedIcon={
                        <CustomCheckedIcon>
                          <Check />
                        </CustomCheckedIcon>
                      }
                      sx={{ cursor: i == 1 ? "default" : "pointer" }}
                      // Optional: Add disabled styling if no access
                      disabled={!hasWabaEditAccess && selectRoleBtnName !== "Select User"}
                    />
                  </StyledTableBodyCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
        <RemoveModal open={saveRightModalOpen} setOpen={setSaveRightModalOpen} btnInfo={btnInfo} heading="Do you want to save access changes?" />
      </div>
    </>
  );
};

export default WabaRights;
